import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/54ff4e87-39d1-46d7-95c3-b67eaee35c2f";
export const REGISTER_URL = "https://a.ntrk2.com/8e76a968-0079-4dc3-83b6-b2065edd9408";

export const LOGIN_URL_MAP = {
  "www-pop369play.com": "https://a.ntrk2.com/8274e95c-f842-4ffa-be8f-c2455ad94e2e",
  "pop369p.com": "https://a.ntrk2.com/8274e95c-f842-4ffa-be8f-c2455ad94e2e",
};

export const REGISTER_URL_MAP = {
  "www-pop369play.com": "https://a.ntrk2.com/cec0f2d2-c786-4634-8273-72f8e053b23e",
  "pop369p.com": "https://a.ntrk2.com/cec0f2d2-c786-4634-8273-72f8e053b23e",
};

export const FLOATING_BANNER_URL = "https://pop369tha.com/cs";

export const DOWNLOAD_URL = "https://pop369.kzw2a.com/download?openExternalBrowser=1&id=clge89ewr6pot7p";

export * from "./codes";
export * from "./context";
